import React from 'react';
import { FaBolt, FaCheckCircle, FaExclamationTriangle, FaTimesCircle } from 'react-icons/fa';
import { SMPSStats } from '../utils/smpsTypes';

interface SMPSStatCardsProps {
  stats: SMPSStats;
}

const SMPSStatCards: React.FC<SMPSStatCardsProps> = ({ stats }) => {
  const cards = [
    {
      id: 'total',
      icon: <FaBolt />,
      value: stats.totalDevices,
      label: 'Total Units',
      trend: null,
    },
    {
      id: 'healthy',
      icon: <FaCheckCircle />,
      value: stats.healthy,
      label: 'Healthy',
      trend: stats.healthy > 0 ? `${Math.round((stats.healthy / stats.totalDevices) * 100)}%` : null,
      trendType: 'up' as const,
    },
    {
      id: 'warning',
      icon: <FaExclamationTriangle />,
      value: stats.warning,
      label: 'Warning',
      trend: null,
      trendType: 'warning' as const,
    },
    {
      id: 'critical',
      icon: <FaTimesCircle />,
      value: stats.critical + stats.offline,
      label: 'Critical/Offline',
      trend: null,
      trendType: 'down' as const,
    },
  ];

  return (
    <div className="dashboard-stats">
      {cards.map((card) => (
        <div key={card.id} className={`stat-card stat-${card.id}`}>
          <div className="stat-header">
            <div className="stat-icon">{card.icon}</div>
            {card.trend && (
              <span className={`stat-trend ${card.trendType}`}>{card.trend}</span>
            )}
          </div>
          <div className="stat-value">{card.value}</div>
          <div className="stat-label">{card.label}</div>
        </div>
      ))}
    </div>
  );
};

export default SMPSStatCards;
